import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchRegionList = createProvider(api.fetchRegionList)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch region list aborted');
    } else {
      console.error('Fetch region list was failed:', error);
    }
    throw error;
  });
